// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_pyoJA clearfix"};